import { Stack } from "@mui/material"
import { parsePhoneNumber } from "libphonenumber-js";
import { useMemo } from "react";

export interface PhoneDisplayProps {
    phone: string;
}

// Resolve the iso2 country code for the sprite flag. This replaces the hidden
// react-phone-input-2 <PhoneInput> widget previously mounted per row purely to
// render a country flag (heavy: full widget + country data per instance).
const getIso2ForPhone = (phone: string): string | null => {
    try {
        const phoneStr = phone.toString();
        const parsed = parsePhoneNumber(phoneStr.startsWith('+') ? phoneStr : `+${phoneStr}`);
        return parsed.country?.toLowerCase() ?? null;
    } catch {
        return null;
    }
};

export const PhoneDisplay = ({ phone }: PhoneDisplayProps) => {
    const iso2 = useMemo(() => (phone ? getIso2ForPhone(phone) : null), [phone]);

    return phone && <Stack direction={"row"} sx={{ alignItems: 'center', gap: '6px' }}>
        {iso2 && (
            // Reuse react-phone-input-2's sprite CSS (already loaded globally)
            // without mounting the widget itself.
            <span className="react-tel-input" style={{ display: 'inline-flex', width: 'auto', position: 'static' }}>
                <span className={`flag ${iso2}`} style={{ display: 'inline-block' }} />
            </span>
        )}
        <a style={{ border: "none", width: 'fit-content', fontSize: '12px', height: '18px', cursor: "pointer", color: "#52bbe8", textDecoration: "underline", background: "transparent", textAlign: 'center', }} href={'tel:' + phone}>
            {phone}
        </a>
    </Stack>
}
